import React from 'react';
import { useIntl } from 'react-intl';

import { convertTimeString, magicStrings } from '../utils';

export interface StoreStatusProps {
  isOpen: boolean;
  isTempClosed: boolean;
  closingTime?: string;
  openingTime?: string;
}

interface Props {
  prefix: string;
  suffix: string;
}

const ActiveStoreStatus = ({ prefix, suffix }: Props) => (
  <>
    { /* eslint-disable-next-line react/jsx-one-expression-per-line */}
    <strong className="green">{prefix}</strong> - {suffix}
  </>
);

const StoreStatus = ({
  isOpen,
  isTempClosed,
  closingTime,
  openingTime,
}: StoreStatusProps) => {
  const intl = useIntl();
  const tempClosedTitle = intl.locale === 'en' ? 'Temporarily Closed' : 'Fermé temporairements';
  if (isTempClosed) {
    return (
      <p>
        <span className="time">{tempClosedTitle}</span>
      </p>
    );
  }
  const storeListingTitleClosed = magicStrings.storeListingTitleClosed(
    intl.locale,
  );
  const storeListingTitleCloses = magicStrings.storeListingTitleCloses(
    intl.locale,
  );
  const storeListingTitleOpen = magicStrings.storeListingTitleOpen(intl.locale);
  const closingTimeLocalized = convertTimeString(closingTime, intl.locale);
  let prefix;
  let suffix;
  if (!isTempClosed && !isOpen) {
    prefix = storeListingTitleClosed;
    suffix = `${openingTime}`;
  } else if (!isTempClosed && isOpen) {
    prefix = storeListingTitleOpen;
    suffix = `${storeListingTitleCloses} ${closingTimeLocalized}`;
  }
  return (
    <p>
      <span className="time">
        {prefix && suffix && (
          <ActiveStoreStatus prefix={prefix} suffix={suffix} />
        )}
      </span>
    </p>
  );
};

export default StoreStatus;
